const WhatsAppIcon = ({ className = "w-4 h-4", ...props }) => (
  <svg
    aria-hidden="true"
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M19.05 4.94A9.86 9.86 0 0 0 12.03 2C6.56 2 2.1 6.45 2.1 11.93c0 1.75.46 3.46 1.33 4.97L2 22l5.25-1.38a9.9 9.9 0 0 0 4.77 1.22h.01c5.47 0 9.93-4.46 9.93-9.94a9.85 9.85 0 0 0-2.91-6.96Zm-7.02 15.22h-.01a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.53 3.69-8.23 8.24-8.23a8.17 8.17 0 0 1 5.83 2.42 8.17 8.17 0 0 1 2.4 5.82c0 4.54-3.69 8.23-8.23 8.23Zm4.5-6.15c-.25-.13-1.47-.72-1.7-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.78.97-.14.16-.29.19-.54.07-.25-.13-1.04-.38-1.98-1.22-.73-.64-1.22-1.42-1.37-1.66-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.43.12-.15.16-.25.25-.42.08-.16.04-.31-.02-.43-.06-.13-.56-1.35-.76-1.84-.2-.48-.4-.41-.56-.42h-.48c-.16 0-.42.06-.64.31-.22.25-.84.82-.84 2 0 1.17.86 2.31.98 2.47.12.16 1.69 2.57 4.08 3.6.57.25 1.02.39 1.37.5.58.18 1.1.16 1.52.1.46-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.07-.11-.23-.17-.48-.3Z" />
  </svg>
);

export default WhatsAppIcon;
